<template>
    <div>
        <v-card-panel title="Основная_информация">

            <!-- поле Тема -->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Тема") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ meeting.Subject }}</div>
                </v-col>
            </v-row>

            <!-- поле Сфера-->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Сфера") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ boardNameString }}</div>
                </v-col>
            </v-row>

            <!-- поле Категория-->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Категория") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ categoriesString }}</div>
                </v-col>
            </v-row>

            <!-- Автор -->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Автор") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">
                        <v-employee-chip :id="meeting.AuthorEmployeeId" :name="meeting.AuthorName" />
                    </div>
                </v-col>
            </v-row>

        </v-card-panel>

        <v-card-panel title="Сроки">
                                    
            <!-- поле Месяц-->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Месяц") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ monthString }}</div>
                </v-col>
            </v-row>

            <!-- поля Период проведения -->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Период_проведения") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ fromDay }} - {{ toDay }}</div>
                </v-col>
            </v-row>

            <!-- Фактический срок -->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Фактический_срок") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ meetingRealDate ? formatDate(meetingRealDate) : $t('не_указано') }}</div>
                </v-col>
            </v-row>

        </v-card-panel>
        
        <v-card-panel title="Ответственные">

            <!-- поле Ответственное управление -->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Ответственное_управление") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ meeting.ResponsibleEnterpriseName ? meeting.ResponsibleEnterpriseName : $t("не_указано")}}</div>
                </v-col>
            </v-row>

            <!-- поле Ответственный специалист -->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Ответственный_специалист") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ meeting.ControllerName ? meeting.ControllerName : $t("не_указано") }}</div>
                </v-col>
            </v-row>

            <!-- поле Контролирующий -->
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Контролирующий") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ meeting.CuratorName ? meeting.CuratorName : $t("не_указано") }}</div>
                </v-col>
            </v-row>

        </v-card-panel>

        <v-card-panel title="Итоги">
            <v-row class="full-width-row" no-gutters>
                <v-col cols="12" sm="12" md="4">
                    <label class="f-label">{{ $t("Итоги") }}</label>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                    <div class="onlyReadData">{{ meeting.Results ? meeting.Results : $t("не_указано") }}</div>
                </v-col>
            </v-row>
        </v-card-panel>

        <v-card-panel title="Вложения">
            <v-row class="full-width-row" no-gutters>
                <v-col cols="12" sm="12" md="12">
                    <div class="cloud-file-list-box">
                        <div class="cloud-items-container">

                            <div v-if="!groupedAttachments.length" class="cfl-placeholder" >{{ $t('Нет_файлов') }}</div>

                            <v-row 
                                v-else
                                dense
                            >
                                <v-attachment-item
                                    v-for="attachment in groupedAttachments[0][1]"
                                    :key="attachment.id"
                                    :attachment="attachment"
                                    :onLoadAttachmet="loadAttachment"
                                    :onAttachmentInfo="openInfoModal"
                                    :isDeleteable="false"
                                    colWidth="4"
                                />
                            </v-row>

                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card-panel>

        <FileInfoDlg ref="FileInfoDlgRef" />

    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { httpAPI } from "@/api/httpAPI";
import FileInfoDlg from '@/components/global/dialogs/FileInfoDlg';

export default {
    name: "MeetingDetailPanelForm",
    components: {
        FileInfoDlg      
    },
    props: {
        meeting: {
            type: Object,
            default: () => null
        }
    },
    asyncComputed: {
        boards : {
            async get() {
                let boardsResponse = await httpAPI({
                    url: `api/plannedevent/boardlist?filter=${JSON.stringify({ Enterprise: this.enterprise })}`,
                    method: 'GET'
                });

                if (!boardsResponse)
                    return [];

                return boardsResponse.data.Payload;
            },
            default: []
        }
    },
    computed: {
        ...mapGetters('planner', { meetingCategories: 'getMeetingCategories', meetingMonths: 'getMeetingMonths', enterprise: 'getFilterEnterprise' }),
        boardNameString() {
            let board = this.boards.find(x => x.id == this.meeting.BoardId);

            if (!board)
                return this.$t("не_указано");

            return this.$i18n.locale == 'kk' ? board.name['kk-KZ'] : board.name['ru-RU'];
        },
        categoriesString() {
            if (!this.meeting.Categories)
                return this.$t("не_указано");

            let result = [];

            this.meetingCategories.forEach((c) => {
                if (this.meeting.Categories.includes(c.id))
                    result.push(c.Value);
            });

            if (result.length == 0)
                return this.$t("не_указано");

            return result.join(", ");
        },
        monthString() {
            let month = this.meetingMonths.find(x => x.id == this.meeting.Month);

            if (!month)
                return this.$t("не_указано");

            return this.$t(month.Value);
        },
        fromDay() {
            return this.meeting.FromDay > 0 ? this.meeting.FromDay : null;
        },
        toDay() {
            return this.meeting.ToDay > 0 ? this.meeting.ToDay : null;
        },
        meetingRealDate() {
            if (this.meeting.RealDate) {
                return this.$moment(this.meeting.RealDate).format('YYYY-MM-DD');
            }
            
            return this.meeting.RealDate;
        },
        groupedAttachments() {
            let groupedAttachments = this.$_.groupBy(this.meeting.AttachmentsSource, (item) => {
                return item.Group;
            });
            
            Object.keys(groupedAttachments).forEach((key) => {            
                groupedAttachments[key] = groupedAttachments[key].map(x => x).sort(function (a, b) { return a.Name.localeCompare(b.Name); });
            });

            return Object.entries(groupedAttachments);
        },
    },
    methods: {
        formatDate (source) {
            return this.$moment(source).format('DD.MM.YYYY');
        },
        async loadAttachment(item) {
            this.$eventBus.$emit('on-download-file', { id: item.Id, name: item.Name, passedType: 'plannedmeetingattachment' });
        },
        async openInfoModal(attachment) {
            try
            {
                await this.$refs.FileInfoDlgRef.open({ ParentType: 'PlannedMeeting', ...attachment });
            }
            catch (ex)
            {
                console.log(ex);
            }
        }
    }
}
</script>